import { render, staticRenderFns } from "./division_standards_list.vue?vue&type=template&id=126e212a&"
import script from "./division_standards_list.vue?vue&type=script&lang=js&"
export * from "./division_standards_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports